var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFacebook = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 50,
  height: 50,
  viewBox: "0 0 50 50"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 25,
  cy: 25,
  r: 24.5,
  stroke: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M22 21h-3v4h3v12h5V25h3.642L31 21h-4v-1.667c0-.955.192-1.333 1.115-1.333H31v-5h-3.808C23.596 13 22 14.583 22 17.615z"
}))));
export default SvgFacebook;